import styled from 'styled-components';
import BaseConfirmationModal from 'global/Modal/BaseConfirmationModal';
import Image from 'global/Image';

export const Modal = styled(BaseConfirmationModal)`
  & .ant-modal-body {
    padding: 18px 0 8px;
  }

  & .base-modal-header {
    margin-bottom: 18px;
  }

  & .button-row {
    padding: 20px;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const Illustration = styled(Image)`
  width: 160px;
  height: auto;

  margin-bottom: 24px;
`;

export const InfoText = styled.p`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 16px;
`;
